function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg030Cyprus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FCFCFC"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M352,233.886c-5.169,0-11.569,0-22.154,0c0,40.784-33.063,73.846-73.846,73.846  c-40.785,0-73.846-33.062-73.846-73.846c-7.138,0-15.016,0-22.154,0c0,43.931,29.509,80.969,69.787,92.377  c-4.415,8.389-3.743,18.951,2.564,26.822c8.285-6.64,16.864-13.515,24.141-19.346c7.277,5.831,15.855,12.705,24.141,19.346  c6.371-7.95,6.998-18.646,2.434-27.075C322.905,314.323,352,277.505,352,233.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M196.923,226.502c0,0,0,36.923,36.923,36.923l7.385,7.385H256c0,0,7.385-22.154,22.154-22.154  c0,0,0-14.769,14.769-14.769s22.154,0,22.154,0s-7.385-29.538,29.538-51.692l-14.769-7.385c0,0-51.692,36.923-88.615,29.538v14.769  h-14.769l-7.385-7.385L196.923,226.502z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg030Cyprus);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0ZDRkNGQzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiM2REE1NDQ7IiBkPSJNMzUyLDIzMy44ODZjLTUuMTY5LDAtMTEuNTY5LDAtMjIuMTU0LDBjMCw0MC43ODQtMzMuMDYzLDczLjg0Ni03My44NDYsNzMuODQ2ICBjLTQwLjc4NSwwLTczLjg0Ni0zMy4wNjItNzMuODQ2LTczLjg0NmMtNy4xMzgsMC0xNS4wMTYsMC0yMi4xNTQsMGMwLDQzLjkzMSwyOS41MDksODAuOTY5LDY5Ljc4Nyw5Mi4zNzcgIGMtNC40MTUsOC4zODktMy43NDMsMTguOTUxLDIuNTY0LDI2LjgyMmM4LjI4NS02LjY0LDE2Ljg2NC0xMy41MTUsMjQuMTQxLTE5LjM0NmM3LjI3Nyw1LjgzMSwxNS44NTUsMTIuNzA1LDI0LjE0MSwxOS4zNDYgIGM2LjM3MS03Ljk1LDYuOTk4LTE4LjY0NiwyLjQzNC0yNy4wNzVDMzIyLjkwNSwzMTQuMzIzLDM1MiwyNzcuNTA1LDM1MiwyMzMuODg2eiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgZD0iTTE5Ni45MjMsMjI2LjUwMmMwLDAsMCwzNi45MjMsMzYuOTIzLDM2LjkyM2w3LjM4NSw3LjM4NUgyNTZjMCwwLDcuMzg1LTIyLjE1NCwyMi4xNTQtMjIuMTU0ICBjMCwwLDAtMTQuNzY5LDE0Ljc2OS0xNC43NjlzMjIuMTU0LDAsMjIuMTU0LDBzLTcuMzg1LTI5LjUzOCwyOS41MzgtNTEuNjkybC0xNC43NjktNy4zODVjMCwwLTUxLjY5MiwzNi45MjMtODguNjE1LDI5LjUzOHYxNC43NjkgIGgtMTQuNzY5bC03LjM4NS03LjM4NUwxOTYuOTIzLDIyNi41MDJ6Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };